import React, {useState} from "react"
import {GroupCelebration} from "@irati/types"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import History, {historyContext} from "@irati/utils/history"
import tracking from "@irati-tracking/recognition/recognition"
import GenericModal from "@irati/ui/src/GenericModal"
import styled from "styled-components"
import authentication from "@irati/auth"
import FormattedMessage from "@irati/utils/lang"
import {Body, H2} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import CrossIcon from "@irati/ui/images/cross.svg"
import {FeedItemType} from "@irati/recognition/enums"
import SuccessManager from "../CreateRecognition/SuccessManager"
import RewardGroupCelebration from "../RewardGroupCelebration"
import ViewCelebration from "./ViewCelebration"
export const VIEW_CELEBRATION = "VIEW_CELEBRATION"
export const REWARD_CELEBRATION = "REWARD_CELEBRATION"
export const SUCCESS_MANAGER = "SUCCESS_MANAGER"
export const ALREADY_REWARDED = "ALREADY_REWARDED"

const modals = [VIEW_CELEBRATION, REWARD_CELEBRATION, SUCCESS_MANAGER, ALREADY_REWARDED]

interface Props {
  redirectToFeed?: boolean
  groupCelebration: GroupCelebration
  onAfterExitModal?: () => void
  hasReward?: boolean
}

const StyledImage = styled.img`
  width: 50px;
  height: 50px;
`

const RecognitionsPopup: React.FC<Props> = (props, context) => {
  const {redirectToFeed, onAfterExitModal, groupCelebration, hasReward} = props
  const theme = useTheme()
  const canReward = authentication.apps("wallet.flexiRewards.canRewardEmployees")
  const getStartModal = () => {
    if (!canReward || !hasReward) {
      return VIEW_CELEBRATION
    }
    if (groupCelebration.walletTransferIds?.length) {
      return ALREADY_REWARDED
    }
    return REWARD_CELEBRATION
  }
  const [show, setShow] = useState(modalStory(modals, getStartModal()))
  const handleHide = () => {
    if (show.REWARD_CELEBRATION) {
      tracking.recognitionCtaClick({
        source: "confirmation_modal",
        type: "greeting_card_cancel"
      })
    }
    setShow(modalStory(modals, null))
  }
  const handleAfterExit = () => {
    if (!anyStoriesOpen(show)) {
      if (redirectToFeed) {
        History.push("/polls", context, {scrollToTop: false})
      }
      onAfterExitModal?.()
    }
  }
  const onRewardCreated = () => {
    tracking.rewardCreatedOnGreetingCard()
    setShow(modalStory(modals, SUCCESS_MANAGER))
  }
  const onErrorReward = () => {
    tracking.rewardErrorOnRecognition({
      source: "greeting_card"
    })
  }
  const onClickSkip = () => {
    handleHide()
  }
  const onSuccessManagerHide = () => {
    handleHide()
  }
  const onSuccessManagerCTAClick = () => {
    History.push("/polls/create-group", context)
  }
  return (
    <>
      <GenericModal show={show[VIEW_CELEBRATION]} onHide={handleHide} onExited={handleAfterExit} hideActions>
        <ViewCelebration groupCelebration={groupCelebration} />
      </GenericModal>
      <GenericModal
        critical
        show={show[ALREADY_REWARDED]}
        onExited={handleAfterExit}
        onConfirm={handleHide}
        proceedButtonText="platform.successStep.success.title">
        <Flex direction="column" alignItems="center" gap={theme.spacing.two} marginBottom={4}>
          <StyledImage src={CrossIcon} />
          <H2>
            <FormattedMessage id="recognition.popup.title.rewardAlreadyCreated" />
          </H2>
          <Body textAlign="center">
            <FormattedMessage id="recognition.popup.msg.rewardAlreadyCreated" />
          </Body>
        </Flex>
      </GenericModal>
      <GenericModal customWidth="800" show={show[REWARD_CELEBRATION]} onHide={handleHide} onExited={handleAfterExit} hideActions>
        <RewardGroupCelebration
          groupCelebration={groupCelebration}
          onErrorReward={onErrorReward}
          onClickButton={onClickSkip}
          onRewardCreated={onRewardCreated}
        />
      </GenericModal>
      <GenericModal show={show[SUCCESS_MANAGER]} onHide={onSuccessManagerHide} onExited={handleAfterExit} hideActions>
        <SuccessManager onClickButton={onSuccessManagerCTAClick} onHide={onSuccessManagerHide} type={FeedItemType.GROUP_RECOGNITION} />
      </GenericModal>
    </>
  )
}

RecognitionsPopup.contextTypes = historyContext

export default RecognitionsPopup
